import React, { useEffect, useState } from "react"
import { motion } from 'framer-motion'
import * as Yup from 'yup'
import { useFormik } from "formik"
import FieldInput from "../../Components/FieldInput"
import Button from "../../Components/Button"
import RasiKattam from "../../Components/RasiKattam"
import AmsaKattam from "../../Components/AmsaKattam"
import { Dropzone, FileMosaic } from "@files-ui/react";
import FieldSelect from "../../Components/FieldSelect"
import FieldMultiSelect from "../../Components/FieldMultiSelect"
import API from '../../Common/API'
import { useHistory } from 'react-router-dom'
import Dialog from "../../Components/Dialog"
import logo from '../../Assets/Images/logo.png'
import { setAlert, setLanguage } from '../../Store/Theme/actions'
import { useDispatch, useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import LanguageSwitcher from "../../Components/LanguageSwitcher"
import PreviewUser from "../HomePages/User/PreviewUser"

const profileTypes = [{ text: 'Bride', value: 'bride' }, { text: 'Groom', value: 'groom' }]
const tProfileTypes = [{ text: 'மணமகள்', value: 'bride' }, { text: 'மணமகன்', value: 'groom' }]
const yesOrNo = [{ text: "Yes", value: true }, { text: "No", value: false }]
const salaryMode = [{ text: 'Month', value: 'month' }, { text: 'Year', value: 'year' }]
const tYesOrNo = [{ text: "ஆம்", value: true }, { text: "இல்லை", value: false }]
const tSalaryMode = [{ text: "மாதம்", value: true }, { text: "ஆண்டு", value: false }]
const pathams = [{ text: '1-ஆம் பாதம்', value: '1-ஆம் பாதம்' }, { text: '2-ஆம் பாதம்', value: '2-ஆம் பாதம்' }, { text: '3-ஆம் பாதம்', value: '3-ஆம் பாதம்' }, { text: '4-ஆம் பாதம்', value: '4-ஆம் பாதம்' }]
const maritalStatus = [{ text: 'Never Married', value: 'Never Married' }, { text: 'Divorced', value: 'Divorced' }, { text: 'Widow', value: 'Widow' }, { text: 'Widower', value: 'Widower' },{text:'Seperated',value:'seperated'}]
const tMaritalStatus = [{ text: 'திருமணம் செய்து கொள்ளவில்லை', value: 'Never Married' }, { text: 'விவாகரத்து பெற்றவர்', value: 'Divorced' }, { text: 'விதவை', value: 'Widow' }, { text: 'மனைவியை இழந்தவன்', value: 'Widower' },{text:"பிரிந்தனர்",value:'seperated'}]
const childOptions = [{ text: "0", value: "0" }, { text: "1", value: "1" }, { text: "2", value: "2" }, { text: "3", value: "3" }, { text: "4", value: "4" }, { text: "5", value: "5" }, { text: 'More than 5', value: 'More than 5' }]

const initialRegisterForm = {
    profileType: '',
    educationalQualification: '',
    firstName: '',
    lastName: '',
    otherEducationalQualification: '',
    surname: '',
    tFirstName: '',
    tLastName: '',
    tSurname: '',
    height: '',
    heightInFeet: '',
    profession: '',
    occupation: "",
    salaryMode: '',
    dateOfBirth: '',
    images: [],
    rasiKattam: [],
    amsaKattam: [],
    password: '',
    confirmPassword: '',
    birthTime: "",
                birthPlace: "",
                thisaiIruppu: "",
                thisaiIruppuDate: "",
                thisaiIruppuMonth: "",
                thisaiIruppuYear: "",
                maritalStatus:"",
                noOfChild : "",
                childDetails : "",
}

const initialFamilyForm = {
    fatherFirstName: '',
    fatherLastName: '',
    fatherSurname: '',
    motherFirstName: '',
    motherLastName: '',
    motherSurname: '',
    fatherNative: '',
    motherNative: '',
    fatherOccupation: '',
    motherOccupation: '',
    isFatherAlive: true,
    isMotherAlive: true,
    numberOfSibilings: 0,
    numberOfMaleSibilings: 0,
    numberOfFemaleSibilings: 0,
    assetInfo:''
}

const initialAdditionalForm = {
    zodiacSign: '',
    star: '',
    flaws: [],
    padham:'',
    // ascendant: '',
    expectedZodiacSigns: [],
    expectedStars: [],
    expectedPersonality: [],
    expectedEducationalQualification: '',
    expectedOccupation: '',
    expectedSalary: '',
    expectedStatus: '',
    expectation:''
}

const initialContactForm = {
    mobileNumber: '',
    whatsappNumber: '',
    nativeAddress: {
        addressLine1: '',
        addressLine2: '',
        city: '',
        state: '',
        district: '',
        pinCode: ''
    },
    presentAddress: {
        addressLine1: '',
        addressLine2: '',
        district: '',
        city: '',
        state: '',
        pinCode: '',
        district: '',
    },
    isSameAddress: false,
    email: ''
}

const Signup = () => {

    const [page1, setPage1] = useState(true)
    const [page2, setPage2] = useState(false)
    const [page3, setPage3] = useState(false)
    const [page4, setPage4] = useState(false)
    const [page5, setPage5] = useState(false)
    const [files, setFiles] = React.useState([]);
    const [pType, setPType] = useState()
    const [fileUrls, setFileUrls] = useState([])
    const [childDetails,setChildDetails]= useState(false)
    const dhisa = useSelector((state) => state.auth.dhisa)
        const tDhisa = useSelector((state) => state.auth.tDhisa)
    const [rasiValues, setRasiValues] = useState([
        [], [], [], [],
        [], null, null, [],
        [], null, null, [],
        [], [], [], []
    ]);

    const [amsaValues, setAmsaValues] = useState([
        [], [], [], [],
        [], null, null, [],
        [], null, null, [],
        [], [], [], []
    ]);
    const [stars, setStars] = useState([])
    const [previewDialog, setPreviewDialog] = useState(false)
    const dispatch = useDispatch()
    const history = useHistory()
    const [submitDisabled, setSubmitDisabled] = useState(false)
    const { t } = useTranslation()
    const lang = useSelector((state) => state.theme.language)
    const [screenLoading, setScreenLoading] = useState(false)
    const [heightType, setHeightType] = useState('cm')
    const tOccupation = useSelector((state)=>state.auth.tOccupation)
    const occupation = useSelector((state)=>state.auth.occupation)
    const flaws =  useSelector((state)=>state.auth.flaws)
    const tFlaws = useSelector((state)=>state.auth.tFlaws)
    const zodiacSigns =  useSelector((state)=>state.auth.zodiacSigns)
    const allStars =  useSelector((state)=>state.auth.allStars)
    const status = useSelector((state)=>state.auth.status)
    const tStatus =  useSelector((state)=>state.auth.tStatus)

    const registerFormSchema = Yup.object().shape({
        profileType: Yup.string().required("Profile type is required"),
        // educationalQualification: Yup.string().required("Educational Qualification is required"),
        firstName: Yup.string().required("First Name is required"),
        surname: Yup.string().required("Surname is required"),
        tFirstName: Yup.string().nullable(),
        tSurname: Yup.string().nullable(),
        dateOfBirth: Yup.string().required("Date of birth is required"),
        heightInFeet: Yup.string().nullable(),
        height: Yup.number().required("Required"),
        images: Yup.array(),
        rasiKattam: Yup.array(),
        amsaKattam: Yup.array(),
        otherEducationalQualification: Yup.string().nullable(),
         maritalStatus:Yup.string().nullable(),
                noOfChild : Yup.string(),
                childDetails : Yup.string().nullable(),
    })

    const familyFormSchema = Yup.object().shape({
        fatherFirstName: Yup.string().required("Required"),
        fatherSurname: Yup.string().required("Required"),
        motherFirstName: Yup.string().required("Required"),
        motherSurname: Yup.string().required("Required"),
        fatherOccupation: Yup.string().nullable(),
        fatherNative: Yup.string().nullable(),
        motherNative: Yup.string().nullable(),
        motherOccupation: Yup.string().nullable(),
        isFatherAlive: Yup.boolean(),
        isMotherAlive: Yup.boolean(),
        numberOfSibilings: Yup.number(),
        numberOfMaleSibilings: Yup.number(),
        numberOfFemaleSibilings: Yup.number(),
        siblingsDetails: Yup.string().nullable(),
        marriedMaleSiblings: Yup.number(),
        marriedFemaleSiblings: Yup.number(),
        assetInfo:Yup.string().nullable(),
    })

    const familyForm = useFormik({
        initialValues: initialFamilyForm,
        validateOnMount: true,
        validationSchema: familyFormSchema,
        enableReinitialize: true,
        onSubmit: (values) => {
            console.log(values)
        }
    })

    const additionalFormSchema = Yup.object().shape({
        zodiacSign: Yup.string().required("Required"),
        star: Yup.string().required("Required"),
        flaws: Yup.array(),
        padham:Yup.string().nullable(),
        // ascendant: Yup.string().required("Required"),
        expectedZodiacSigns: Yup.array(),
        expectedStars: Yup.array(),
        expectedPersonality: Yup.array(),
        expectedEducationalQualification: Yup.string().nullable(),
        expectedOccupation: Yup.array(),
        expectedSalary: Yup.string().nullable(),
        expectedStatus: Yup.array(),
        expectation : Yup.string().nullable(),
        password: Yup.string().required("Password is required"),
        confirmPassword: Yup.string().required("Confirm Password is required"),
    })

    const additionalForm = useFormik({
        initialValues: initialAdditionalForm,
        validateOnMount: true,
        validationSchema: additionalFormSchema,
        enableReinitialize: true,
        onSubmit: (values) => {
            console.log(values)
        }
    })

    const contactFormSchema = Yup.object().shape({
        mobileNumber: Yup.string().required("Mobile number is required"),
        whatsappNumber: Yup.string().nullable(), 
        nativeAddress: Yup.object().shape({
            addressLine1: Yup.string().required("Address Line 1 is required"),
            addressLine2: Yup.string().nullable(),
            city: Yup.string().required("City is required"),
            state: Yup.string().required("State is required"),
            district: Yup.string().required("District is required"),
            pinCode: Yup.string().required("Pincode is required")
        }),
        presentAddress: Yup.object().shape({
            addressLine1: Yup.string().required("Address Line 1 is required"),
            addressLine2: Yup.string().nullable(),
            city: Yup.string().required("City is required"),
            state: Yup.string().required("State is required"),
            district: Yup.string().required("District is required"),
            pinCode: Yup.string().required("Pincode is required")
        }),
        isSameAddress: Yup.boolean(),
        email: Yup.string().nullable(),
    })


    const contactForm = useFormik({
        initialValues: initialContactForm,
        validateOnMount: true,
        validationSchema: contactFormSchema,
        enableReinitialize: true,
        onSubmit: (values) => {
            console.log(values)
        }
    })

    const registerForm = useFormik({
        initialValues: initialRegisterForm,
        validateOnMount: true,
        validationSchema: registerFormSchema,
        enableReinitialize: true,
        onSubmit: (values) => {

            setSubmitDisabled(true)
            setScreenLoading(true)
            values.familyInformation = familyForm.values
            values.contactInformation = contactForm.values
            values.additionalInformation = additionalForm.values
            values.heightInFeet = `${values.heightInFeet.split('.')[0]} ft ${values.heightInFeet.split('.')[1]} in`
            const formData = new FormData();
            formData.append('userData', JSON.stringify(values));
            files.forEach((file) => {
                formData.append('files', file.file);
            });
            if (values.additionalInformation.password === values.additionalInformation.confirmPassword) {
                API.post('/auth/register', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then((res) => {
                    if (res.status === 200 && res.data.data.error) {
                        dispatch(setAlert({title:"Error",subtitle:res.data.data.message,active:true,type:'error'}))
                        setSubmitDisabled(false)
                        setScreenLoading(false)
                    }else if(res.status === 200){
                        dispatch(setAlert({ type: 'success', title: 'Registration Success', subtitle: 'Your registration is successfull.', active: true }))
                        history.push('/auth/login')
                        setSubmitDisabled(false)
                        setScreenLoading(false)
                    }
                }).catch((err) => {
                    setSubmitDisabled(false)
                })
            } else {
                setSubmitDisabled(false)
                setScreenLoading(false)
                registerForm.setErrors({ 'confirmPassword': 'Password and Confirm Password should be same' })
            }
        }
    })


    const convertHeight = (cm) => {
        const totalInches = parseInt(cm) * 0.3937;
        const feet = Math.floor(totalInches / 12);
        const inches = Math.round(totalInches % 12);
        registerForm.setValues({ ...registerForm.values, heightInFeet: `${feet}.${inches}` })
    };

    const convertHeightToCm = (feet) => {
        const cm = Math.round(parseFloat(feet) * 30.48);
        registerForm.setValues({ ...registerForm.values, height: cm })
    }

    const validateForms = async (page) => {
        registerForm.setValues({ ...registerForm.values, additionalInformation: additionalForm.values, familyInformation: familyForm.values, contactInformation: contactForm.values, images: [...files], previewUrls: [...fileUrls], rasiKattam: [...rasiValues], amsaKattam: [...amsaValues] })
        if (page === 1) {
            const errors = await registerForm.validateForm(); // Trigger validation
            registerForm.setTouched(
                Object.keys(registerForm.values).reduce((acc, key) => {
                    if (typeof registerForm.values[key] === 'object') {
                        acc[key] = Object.keys(registerForm.values[key]).reduce(
                            (subAcc, subKey) => ({ ...subAcc, [subKey]: true }),
                            {}
                        );
                    } else {
                        acc[key] = true;
                    }
                    return acc;
                }, {}),
                true
            );
            if (Object.keys(errors).length === 0) {
                setPage1(false);
                setPage2(true);
                setPage3(false);
                setPage4(false);
                setPage5(false);
                const firstName = await API.post('/common/translate', { text: registerForm.values.firstName });
                const surName = await API.post('/common/translate', { text: registerForm.values.surname });
                registerForm.setValues({ ...registerForm.values, tFirstName: firstName.data.data.translatedText, tSurname: surName.data.data.translatedText })
            }
        } else if (page === 2) {
            const errors = await familyForm.validateForm(); // Trigger validation
            familyForm.setTouched(
                Object.keys(familyForm.values).reduce((acc, key) => {
                    if (typeof familyForm.values[key] === 'object') {
                        acc[key] = Object.keys(familyForm.values[key]).reduce(
                            (subAcc, subKey) => ({ ...subAcc, [subKey]: true }),
                            {}
                        );
                    } else {
                        acc[key] = true;
                    }
                    return acc;
                }, {}),
                true
            );
            if (Object.keys(errors).length === 0) {
                setPage1(false)
                setPage2(false)
                setPage3(true)
                setPage4(false)
                setPage5(false)
            }
        } else if (page === 3) {
            const errors = await additionalForm.validateForm(); // Trigger validation
            additionalForm.setTouched(
                Object.keys(additionalForm.values).reduce((acc, key) => {
                    if (typeof additionalForm.values[key] === 'object') {
                        acc[key] = Object.keys(additionalForm.values[key]).reduce(
                            (subAcc, subKey) => ({ ...subAcc, [subKey]: true }),
                            {}
                        );
                    } else {
                        acc[key] = true;
                    }
                    return acc;
                }, {}),
                true
            );
            if (Object.keys(errors).length === 0) {
                setPage1(false)
                setPage2(false)
                setPage3(false)
                setPage4(true)
                setPage5(false)
            }
        } else if (page === 4) {
            const errors = await contactForm.validateForm(); // Trigger validation
            contactForm.setTouched(
                Object.keys(contactForm.values).reduce((acc, key) => {
                    if (typeof contactForm.values[key] === 'object') {
                        acc[key] = Object.keys(contactForm.values[key]).reduce(
                            (subAcc, subKey) => ({ ...subAcc, [subKey]: true }),
                            {}
                        );
                    } else {
                        acc[key] = true;
                    }
                    return acc;
                }, {}),
                true
            );

            if (Object.keys(errors).length === 0) {
                setPage1(false)
                setPage2(false)
                setPage3(false)
                setPage4(false)
                setPage5(true)
            }
        } else if (page === 5) {
            setPage1(false)
            setPage2(false)
            setPage3(false)
            setPage4(false)
            setPage5(true)
            setPreviewDialog(true)
        }
    }

    const backPage = (page) => {
        if (page === 1) {
            setPage1(true)
            setPage2(false)
            setPage3(false)
            setPage4(false)
            setPage5(false)
        } else if (page === 2) {
            setPage1(false)
            setPage2(true)
            setPage3(false)
            setPage4(false)
            setPage5(false)
        } else if (page === 3) {
            setPage1(false)
            setPage2(false)
            setPage3(true)
            setPage4(false)
            setPage5(false)
        } else if (page === 4) {
            setPage1(false)
            setPage2(false)
            setPage3(false)
            setPage4(true)
            setPage5(false)
        } else if (page === 5) {
            setPage1(false)
            setPage2(false)
            setPage3(false)
            setPage4(false)
            setPage5(true)
        }
    }


    const updateFiles = (incommingFiles) => {
        setFiles(incommingFiles);

        const newUrls = incommingFiles.map((file) => URL.createObjectURL(file.file));
        setFileUrls(newUrls);
        //even your own upload implementation
    };
    const removeFile = (id) => {
        const updatedFiles = files.filter((x) => x.id !== id);
        const removedFileIndex = files.findIndex((file) => file.id === id); //find the index of the removed file

        setFiles(updatedFiles);

        // Remove the corresponding URL
        setFileUrls((prevUrls) => {
            const newUrls = [...prevUrls];
            newUrls.splice(removedFileIndex, 1); // Remove the url at the same index
            return newUrls;
        });
    };

    const getStarsByZodiac = (values) => {
        API.post(`/common/getStarByZodiac`, { zodiacId: values }).then((starRes) => {
            if (starRes.status === 200) {
                setStars(starRes.data.data.map((c) => { return { text: c.star, value: c._id } }))
            }
        })
    }

    const getPresentAddress = (values) => {
        if (values.length === 6) {
            API.get(`/common/getLocationByPincode?pinCode=${parseInt(values)}`).then((locationRes) => {
                if (locationRes.status === 200) {
                    const location = locationRes.data.data
                    contactForm.setValues({ ...contactForm.values, presentAddress: { city: location.city, state: location.state, district: location.district, pinCode: location.pinCode } })
                }
            })
        } else if (values.length === 0) {
            contactForm.setValues({ ...contactForm.values, presentAddress: { city: '', state: '', district: '', pinCode: '' } })
        }
    }

    const getNativeAddress = (values) => {
        if (values.length === 6) {
            API.get(`/common/getLocationByPincode?pinCode=${parseInt(values)}`).then((locationRes) => {
                if (locationRes.status === 200) {
                    const location = locationRes.data.data
                    contactForm.setValues({ ...contactForm.values, nativeAddress: { city: location.city, state: location.state, district: location.district, pinCode: location.pinCode } })
                }
            })
        } else if (values.length === 0) {
            contactForm.setValues({ ...contactForm.values, nativeAddress: { city: '', state: '', district: '', pinCode: '' } })
        }
    }

    const sameAddress = (value) => {
        if (value.target.checked) {
            contactForm.setValues({ ...contactForm.values, isSameAddress: value.target.checked, nativeAddress: contactForm.values.presentAddress })
        } else {
            contactForm.setValues({ ...contactForm.values, isSameAddress: value.target.checked, nativeAddress: { addressLine1: '', addressLine2: '', city: '', state: '', district: '', pinCode: '' } })
        }
    }

    const translateValues = async (value, key, actualValue) => {
        if (lang === 'ta' && key === 'firstName') {
            registerForm.setValues({ ...registerForm.values, firstName: actualValue, tFirstName: value })
        } else if (lang === 'ta' && key === 'lastName') {
            registerForm.setValues({ ...registerForm.values, lastName: actualValue, tLastName: value })
        } else if (lang === 'ta' && key === 'surname') {
            registerForm.setValues({ ...registerForm.values, surname: actualValue, tSurname: value })
        }
    }

   useEffect(()=>{
    if(contactForm.values.mobileNumber.toString().length === 10){
            API.post(`/common/mobileAlreadyExists`,{mobileNumber:contactForm.values.mobileNumber}).then((valueRes)=>{
                if(valueRes.status === 200){
                    contactForm.setErrors({ mobileNumber: '' });
                }
            }).catch((err)=>{
                contactForm.setErrors({ mobileNumber: 'Mobile number already exists'})
            })
        }
   },[contactForm.values.mobileNumber])
    const checkForKids = (values)=>{
    if(values !== 'Never Married'){
        setChildDetails(true)
    }
   }

    return (
        <motion.div className="min-h-screen w-full h-full overflow-y-scroll flex flex-col lg:px-10 py-10 registerBg relative">
            <motion.div className="w-full flex flex-row py-10 px-2 md:px-0 justify-between">
                <motion.div className="text-xl font-bold px-5 py-2 cursor-pointer bg-primeColor" onClick={()=>history.push('/')}>
                    <img src={logo} alt="Logo" height={100} width={100}/>
                </motion.div>
                <motion.div className="flex flex-row justify-between items-center">
                    <LanguageSwitcher onToggle={(lang) => dispatch(setLanguage(lang))} />
                    <p className="text-xl font-bold text-primeColor mx-10">{t('Register')}</p>
                </motion.div>
            </motion.div>
            {/* Page 1 */}
            {page1 && <motion.div className="h-full w-full grid grid-cols-1">
                <motion.div className="w-full gap-2 flex flex-col h-full justify-center">
                    <p className="text-4xl font-bold text-primeColor">{t('Basic Information')}</p>
                    <p className="text-md">{t("Fill your basic information")}</p>
                </motion.div>
                <motion.div className="w-full h-full grid grid-cols-1 md:grid-cols-4 sm:grid-cols-1 gap-5">
                    <FieldSelect
                        injectClass={'bg-white'}
                        label={t('Bride/Groom')}
                        fieldProps={registerForm.getFieldProps('profileType')}
                        fieldMeta={registerForm.getFieldMeta('profileType')}
                        fieldHelper={registerForm.getFieldHelpers('profileType')}
                        edit={true}
                        dataLoaded={true}
                        options={lang === 'en' ? profileTypes : tProfileTypes}
                        onChange={(ev) => setPType(profileTypes.filter((x) => x.value === ev)[0].text)}
                    />

                    <FieldInput placeholder={'BE, ME, MTECH, MBBS...'} injectClass={'bg-white'} label={'Educational Qualification'} fieldProps={registerForm.getFieldProps('otherEducationalQualification')} fieldMeta={registerForm.getFieldMeta('otherEducationalQualification')} fieldHelper={registerForm.getFieldHelpers('otherEducationalQualification')} edit={true} dataLoaded={true} />
                    <FieldSelect
                                injectClass={'bg-white'}
                                label={t('Marital Status')}
                                fieldProps={registerForm.getFieldProps('maritalStatus')}
                                fieldMeta={registerForm.getFieldMeta('maritalStatus')}
                                fieldHelper={registerForm.getFieldHelpers('maritalStatus')}
                                edit={true}
                                dataLoaded={true}
                                options={lang === 'en' ? maritalStatus : tMaritalStatus}
                                onChange={(ev) => checkForKids(ev)}
                            />
                            {childDetails && <FieldSelect label={t('No of childs')} fieldProps={registerForm.getFieldProps('noOfChild')} fieldHelper={registerForm.getFieldHelpers('noOfChild')} fieldMeta={registerForm.getFieldMeta('noOfChild')} edit={true} dataLoaded={true} options={childOptions}/>}
                            {registerForm.values.noOfChild !== "0" && registerForm.values.noOfChild !== '' && <FieldInput type='textarea' label={'Child Details'} fieldProps={registerForm.getFieldProps('childDetails')} fieldHelper={registerForm.getFieldHelpers('childDetails')} fieldMeta={registerForm.getFieldMeta('childDetails')} edit={true} dataLoaded={true}/>} 
                </motion.div>
                <motion.div className="w-full h-full grid grid-cols-1 md:grid-cols-4 sm:grid-cols-1 gap-5">
                    <FieldInput translate={lang === 'ta' ? true : false} injectClass={'bg-white'} label={t(`${pType ? pType : ''} Name`)} fieldProps={lang === 'ta' ? registerForm.getFieldProps('tFirstName') : registerForm.getFieldProps('firstName')} fieldMeta={lang === 'ta' ? registerForm.getFieldMeta('tFirstName') : registerForm.getFieldMeta('firstName')} fieldHelper={lang === 'ta' ? registerForm.getFieldHelpers('tFirstName') : registerForm.getFieldHelpers('firstName')} edit={true} dataLoaded={true} onChange={(ev) => translateValues(ev.translatedValue, 'firstName', ev)} />
                    {/* <FieldInput translate={lang === 'ta' ? true : false} injectClass={'bg-white'} label={t(`${pType ? pType : ''} Last Name`)} fieldProps={lang === 'ta' ? registerForm.getFieldProps('tLastName') : registerForm.getFieldProps('lastName')} fieldMeta={lang === 'ta' ? registerForm.getFieldMeta('tLastName') : registerForm.getFieldMeta('lastName')} fieldHelper={lang === 'ta' ? registerForm.getFieldHelpers('tLastName') : registerForm.getFieldHelpers('lastName')} edit={true} dataLoaded={true} onChange={(ev) => translateValues(ev.translatedValue, 'lastName', ev.value)} /> */}
                    <FieldInput translate={lang === 'ta' ? true : false} injectClass={'bg-white'} label={t(`${pType ? pType : ''} Surname`)} fieldProps={lang === 'ta' ? registerForm.getFieldProps('tSurname') : registerForm.getFieldProps('surname')} fieldMeta={lang === 'ta' ? registerForm.getFieldMeta('tSurname') : registerForm.getFieldMeta('surname')} fieldHelper={lang === 'ta' ? registerForm.getFieldHelpers('tSurname') : registerForm.getFieldHelpers('surname')} edit={true} dataLoaded={true} onChange={(ev) => translateValues(ev.translatedValue, 'surname', ev)} />
                    <FieldInput type="date" dateInjectClass={'bg-white'} label={t(`Date of birth`)} fieldProps={registerForm.getFieldProps('dateOfBirth')} fieldMeta={registerForm.getFieldMeta('dateOfBirth')} fieldHelper={registerForm.getFieldHelpers('dateOfBirth')} edit={true} dataLoaded={true} />
                    <motion.div className="flex flex-col gap-2">
                        <label className="font-medium text-sm">{t('Choose height measurement')}</label>

                        <motion.div className="flex items-center gap-4">
                            <label className="flex items-center gap-1">
                                <input
                                    type="radio"
                                    name="heightUnit"
                                    checked={heightType === 'cm'}
                                    onChange={() => setHeightType('cm')}
                                    className="accent-blue-500"
                                />
                                <span>{t('In CM')}</span>
                            </label>

                            <label className="flex items-center gap-1">
                                <input
                                    type="radio"
                                    name="heightUnit"
                                    checked={heightType === 'ft'}
                                    onChange={() => setHeightType('ft')}
                                    className="accent-blue-500"
                                />
                                <span>{t('In Feet')}</span>
                            </label>
                        </motion.div>
                    </motion.div>
                    <FieldInput injectClass={'bg-white'} label={t(`${pType ? pType : ''} Height In ${heightType === 'cm' ? 'CM' : 'Feet'}`)} fieldProps={heightType === 'cm' ? registerForm.getFieldProps('height') : registerForm.getFieldProps('heightInFeet')}
                        fieldMeta={heightType === 'cm' ? registerForm.getFieldMeta('height') : registerForm.getFieldProps('heightInFeet')} fieldHelper={heightType === 'cm' ? registerForm.getFieldHelpers('height') : registerForm.getFieldProps('heightInFeet')} edit={true} dataLoaded={true} onChange={(ev) => heightType === 'cm' ? convertHeight(ev) : convertHeightToCm(ev)} />
                    <FieldSelect injectClass={'bg-white'} label={t(`${pType ? pType : ''} Profession`)} fieldProps={registerForm.getFieldProps('profession')} fieldMeta={registerForm.getFieldMeta('profession')} fieldHelper={registerForm.getFieldHelpers('profession')} edit={true} dataLoaded={true} options={lang === 'en' ? occupation : tOccupation} />
                    <FieldInput injectClass={'bg-white'} label={t(`${pType ? pType : ''} Occupation`)} placeholder="Software Engineer/ Pediatrician/ " fieldProps={registerForm.getFieldProps('occupation')} fieldMeta={registerForm.getFieldMeta('occupation')} fieldHelper={registerForm.getFieldHelpers('occupation')} edit={true} dataLoaded={true} />
                    <FieldInput translate={lang === 'ta' ? true : false} injectClass={'bg-white'} label={t(`${pType ? pType : ''} Occupation Location`)} fieldProps={registerForm.getFieldProps('occupationLocation')} fieldMeta={registerForm.getFieldMeta('occupationLocation')} fieldHelper={registerForm.getFieldHelpers('occupationLocation')} edit={true} dataLoaded={true} />
                    <FieldInput injectClass={'bg-white'} label={t(`${pType ? pType : ''} Salary`)} fieldProps={registerForm.getFieldProps('salary')} fieldMeta={registerForm.getFieldMeta('salary')} fieldHelper={registerForm.getFieldHelpers('salary')} edit={true} dataLoaded={true} />
                    <FieldSelect injectClass={'bg-white'} label={t(`${pType ? pType : ''} Salary Mode`)} fieldProps={registerForm.getFieldProps('salaryMode')} fieldMeta={registerForm.getFieldMeta('salaryMode')} fieldHelper={registerForm.getFieldHelpers('salaryMode')} edit={true} dataLoaded={true} options={salaryMode} />
                </motion.div>
                <motion.div className="w-full flex bottom inset-x-0 flex-row justify-end">
                    <motion.div className="w-96 flex flex-row justify-start">
                        <Button injectClass={'rounded-full w-full'} type="secondary" onClick={() => history.goBack()}>{t('Cancel')}</Button>
                        <Button injectClass={'rounded-full w-full'} type="primary" onClick={() => validateForms(1)}>{t('Next')}</Button>
                    </motion.div>
                </motion.div>
            </motion.div>}
            {/* Page 2 */}
            {page2 && <motion.div className="h-full w-full grid grid-cols-1">
                <motion.div className="w-full flex gap-2 flex-col h-full justify-center">
                    <p className="text-4xl font-bold text-primeColor">{t('Family Information')}</p>
                    <p className="text-md">{t('Fill your family information')}</p>
                </motion.div>
                <motion.div className="w-full h-full grid grid-cols-1 md:grid-cols-4 sm:grid-cols-1 gap-5">
                    <FieldInput translate={lang === 'ta' ? true : false} injectClass={'bg-white'} label={t(`Father Name`)} fieldProps={familyForm.getFieldProps('fatherFirstName')} fieldMeta={familyForm.getFieldMeta('fatherFirstName')} fieldHelper={familyForm.getFieldHelpers('fatherFirstName')} edit={true} dataLoaded={true} />
                    <FieldInput translate={lang === 'ta' ? true : false} injectClass={'bg-white'} label={t(`Father Surname`)} fieldProps={familyForm.getFieldProps('fatherSurname')} fieldMeta={familyForm.getFieldMeta('fatherSurname')} fieldHelper={familyForm.getFieldHelpers('fatherSurname')} edit={true} dataLoaded={true} />
                    <FieldSelect injectClass={'bg-white'} label={t('Father is alive?')} fieldProps={familyForm.getFieldProps('isFatherAlive')} fieldMeta={familyForm.getFieldMeta('isFatherAlive')} fieldHelper={familyForm.getFieldHelpers('isFatherAlive')} edit={true} dataLoaded={true} options={lang === 'en' ? yesOrNo : tYesOrNo} />
                    <FieldInput injectClass={'bg-white'} label={t(`Father Occupation`)} fieldProps={familyForm.getFieldProps('fatherOccupation')} fieldMeta={familyForm.getFieldMeta('fatherOccupation')} fieldHelper={familyForm.getFieldHelpers('fatherOccupation')} edit={true} dataLoaded={true}  />
                    <FieldInput translate={lang === 'ta' ? true : false} injectClass={'bg-white'} label={t(`Mother Name`)} fieldProps={familyForm.getFieldProps('motherFirstName')} fieldMeta={familyForm.getFieldMeta('motherFirstName')} fieldHelper={familyForm.getFieldHelpers('motherFirstName')} edit={true} dataLoaded={true} />
                    <FieldInput translate={lang === 'ta' ? true : false} injectClass={'bg-white'} label={t(`Mother Surname`)} fieldProps={familyForm.getFieldProps('motherSurname')} fieldMeta={familyForm.getFieldMeta('motherSurname')} fieldHelper={familyForm.getFieldHelpers('motherSurname')} edit={true} dataLoaded={true} />
                    <FieldSelect injectClass={'bg-white'} label={t('Mother is alive?')} fieldProps={familyForm.getFieldProps('isMotherAlive')} fieldMeta={familyForm.getFieldMeta('isMotherAlive')} fieldHelper={familyForm.getFieldHelpers('isMotherAlive')} edit={true} dataLoaded={true} options={lang === 'en' ? yesOrNo : tYesOrNo} />
                    <FieldInput injectClass={'bg-white'} label={t(`Mother Occupation`)} fieldProps={familyForm.getFieldProps('motherOccupation')} fieldMeta={familyForm.getFieldMeta('motherOccupation')} fieldHelper={familyForm.getFieldHelpers('motherOccupation')} edit={true} dataLoaded={true}  />
                    <FieldInput translate={lang === 'ta' ? true : false} injectClass={'bg-white'} label={t(`Father Native`)} fieldProps={familyForm.getFieldProps('fatherNative')} fieldMeta={familyForm.getFieldMeta('fatherNative')} fieldHelper={familyForm.getFieldHelpers('fatherNative')} edit={true} dataLoaded={true} />
                    <FieldInput translate={lang === 'ta' ? true : false} injectClass={'bg-white'} label={t(`Mother Native`)} fieldProps={familyForm.getFieldProps('motherNative')} fieldMeta={familyForm.getFieldMeta('motherNative')} fieldHelper={familyForm.getFieldHelpers('motherNative')} edit={true} dataLoaded={true} />
                    <FieldInput injectClass={'bg-white'} label={t(`Number of male siblings`)} fieldProps={familyForm.getFieldProps('numberOfMaleSiblings')} fieldMeta={familyForm.getFieldMeta('numberOfMaleSiblings')} fieldHelper={familyForm.getFieldHelpers('numberOfMaleSiblings')} edit={true} dataLoaded={true} />
                    <FieldInput injectClass={'bg-white'} label={t(`Number of female siblings`)} fieldProps={familyForm.getFieldProps('numberOfFemaleSiblings')} fieldMeta={familyForm.getFieldMeta('numberOfFemaleSiblings')} fieldHelper={familyForm.getFieldHelpers('numberOfFemaleSiblings')} edit={true} dataLoaded={true} />
                    <FieldInput injectClass={'bg-white'} label={t(`Number of female married siblings`)} fieldProps={familyForm.getFieldProps('marriedFemaleSiblings')} fieldMeta={familyForm.getFieldMeta('marriedFemaleSiblings')} fieldHelper={familyForm.getFieldHelpers('marriedFemaleSiblings')} edit={true} dataLoaded={true} />
                    <FieldInput injectClass={'bg-white'} label={t(`Number of male married siblings`)} fieldProps={familyForm.getFieldProps('marriedMaleSiblings')} fieldMeta={familyForm.getFieldMeta('marriedMaleSiblings')} fieldHelper={familyForm.getFieldHelpers('marriedMaleSiblings')} edit={true} dataLoaded={true} />
                    <motion.div className="col-span-2">
                        <FieldInput injectClass={'bg-white'} type="textarea" label={t(`Siblings Details`)} fieldProps={familyForm.getFieldProps('siblingsDetails')} fieldHelper={familyForm.getFieldHelpers('siblingsDetails')} fieldMeta={familyForm.getFieldMeta('siblingsDetails')} edit={true} dataLoaded={true} />
                    </motion.div>
                    <motion.div className="col-span-2">
                        <FieldInput injectClass={'bg-white'} type="textarea" label={t(`Asset Information`)} fieldProps={familyForm.getFieldProps('assetInfo')} fieldHelper={familyForm.getFieldHelpers('assetInfo')} fieldMeta={familyForm.getFieldMeta('assetInfo')} edit={true} dataLoaded={true} />
                    </motion.div>
                </motion.div>
                <motion.div className="w-full flex flex-row justify-end">
                    <motion.div className="w-96 flex flex-row justify-start">
                        <Button injectClass={'rounded-full w-full'} type="secondary" onClick={() => backPage(1)}>{t('Back')}</Button>
                        <Button injectClass={'rounded-full w-full'} type="primary" onClick={() => validateForms(2)}>{t('Next')}</Button>
                    </motion.div>
                </motion.div>
            </motion.div>}
            {/* Page 3 */}
            {page3 && <motion.div className="h-full w-full grid grid-cols-1">
                <motion.div className="w-full flex gap-2 px-1 flex-col h-full justify-center">
                    <p className="text-4xl font-bold text-primeColor">{t('Additional Information')}</p>
                    <p className="text-md">{t('Fill your additional information')}</p>
                </motion.div>
                <motion.div className="w-full grid grid-cols-1 md:grid-cols-4 sm:grid-cols-1 gap-5">
                    <FieldSelect injectClass={'bg-white'} label={t('Zodiac Sign')} fieldProps={additionalForm.getFieldProps('zodiacSign')} fieldMeta={additionalForm.getFieldMeta('zodiacSign')} fieldHelper={additionalForm.getFieldHelpers('zodiacSign')} edit={true} dataLoaded={true} options={zodiacSigns} onChange={(ev) => { getStarsByZodiac(ev) }} />
                    <FieldSelect injectClass={'bg-white'} placeholder={t('Star')} label={t(`Star`)} fieldProps={additionalForm.getFieldProps('star')} fieldMeta={additionalForm.getFieldMeta('star')} fieldHelper={additionalForm.getFieldHelpers('star')} edit={true} dataLoaded={true} options={stars} />
                    <FieldSelect injectClass={'bg-white'} placeholder={t('Padham')} label={t(`Padham`)} fieldProps={additionalForm.getFieldProps('padham')} fieldMeta={additionalForm.getFieldMeta('padham')} fieldHelper={additionalForm.getFieldHelpers('padham')} edit={true} dataLoaded={true} options={pathams} />
                    <FieldMultiSelect injectClass={'bg-white'} placeholder={t('Flaws')} label={t(`Flaws`)} fieldProps={additionalForm.getFieldProps('flaws')} fieldMeta={additionalForm.getFieldMeta('flaws')} fieldHelper={additionalForm.getFieldHelpers('flaws')} edit={true} dataLoaded={true} options={lang === 'en' ? flaws : tFlaws} />
                </motion.div>
                <motion.div className="h-fit my-5 gap-5 w-full grid grid-cols-1">
                        <motion.div className="w-full flex gap-2 flex-col h-full justify-center">
                            <p className="text-4xl font-bold text-primeColor">{t('Birth Information')}</p>
                        </motion.div>
                        <motion.div className="w-full h-full grid grid-cols-1 md:grid-cols-4 sm:grid-cols-1 gap-5">
                            <FieldInput injectClass={'bg-white'} type="time" label={t(`Birth Time`)} fieldProps={registerForm.getFieldProps('birthTime')} fieldMeta={registerForm.getFieldMeta('birthTime')} fieldHelper={registerForm.getFieldHelpers('birthTime')} edit={true} dataLoaded={true} onChange={(ev) => getPresentAddress(ev)} />
                            <FieldInput injectClass={'bg-white'} label={t('Birth Place')} fieldProps={registerForm.getFieldProps('birthPlace')} fieldMeta={registerForm.getFieldMeta('birthPlace')} fieldHelper={registerForm.getFieldHelpers('birthPlace')} edit={true} dataLoaded={true} />
                            <FieldSelect injectClass={'bg-white'} label={t(`Dhisai Iruppu`)} fieldProps={registerForm.getFieldProps('thisaiIruppu')} fieldMeta={registerForm.getFieldMeta('thisaiIruppu')} fieldHelper={registerForm.getFieldHelpers('thisaiIruppu')} edit={true} dataLoaded={true} options={lang === 'en' ? dhisa : tDhisa} />
                            <FieldInput injectClass={'bg-white'} label={t(`Dhisai Iruppu Date`)} fieldProps={registerForm.getFieldProps('thisaiIruppuDate')} fieldMeta={registerForm.getFieldMeta('thisaiIruppuDate')} fieldHelper={registerForm.getFieldHelpers('thisaiIruppuDate')} edit={true} dataLoaded={true} />
                            <FieldInput injectClass={'bg-white'} label={t(`Dhisai Iruppu Month`)} fieldProps={registerForm.getFieldProps('thisaiIruppuMonth')} fieldMeta={registerForm.getFieldMeta('thisaiIruppuMonth')} fieldHelper={registerForm.getFieldHelpers('thisaiIruppuMonth')} edit={true} dataLoaded={true} />
                            <FieldInput injectClass={'bg-white'} label={t(`Dhisai Iruppu Year`)} fieldProps={registerForm.getFieldProps('thisaiIruppuYear')} fieldMeta={registerForm.getFieldMeta('thisaiIruppuYear')} fieldHelper={registerForm.getFieldHelpers('thisaiIruppuYear')} edit={true} dataLoaded={true} />
                        </motion.div>
                    </motion.div>
                <motion.div className="w-full flex px-1 gap-2 flex-col my-5 justify-center">
                    <p className="text-xl font-bold text-primeColor">{t('Expectations')}</p>
                    <p className="text-md">{t('Fill your expected informations')}</p>
                </motion.div>
                <motion.div className="w-full h-full grid grid-cols-1 md:grid-cols-4 sm:grid-cols-1 gap-5">
                    <FieldMultiSelect injectClass={'bg-white'} label={t(`Zodiac Sign`)} fieldProps={additionalForm.getFieldProps('expectedZodiacSigns')} fieldMeta={additionalForm.getFieldMeta('expectedZodiacSigns')} fieldHelper={additionalForm.getFieldHelpers('expectedZodiacSigns')} edit={true} dataLoaded={true} options={zodiacSigns} />
                    <FieldMultiSelect injectClass={'bg-white'} label={t('Stars')} fieldProps={additionalForm.getFieldProps('expectedStars')} fieldMeta={additionalForm.getFieldMeta('expectedStars')} fieldHelper={additionalForm.getFieldHelpers('expectedStars')} edit={true} dataLoaded={true} options={allStars} />
                    {/* <FieldInput injectClass={'bg-white'} label={`Perssonality`} fieldProps={additionalForm.getFieldProps('expectedPersonality')} fieldMeta={additionalForm.getFieldMeta('expectedPersonality')} fieldHelper={additionalForm.getFieldHelpers('expectedPersonality')} edit={true} dataLoaded={true} /> */}
                    <FieldInput injectClass={'bg-white'} label={t(`Educational Qualification`)} fieldProps={additionalForm.getFieldProps('expectedEducationalQualification')} fieldMeta={additionalForm.getFieldMeta('expectedEducationalQualification')} fieldHelper={additionalForm.getFieldHelpers('expectedEducationalQualification')} edit={true} dataLoaded={true}  />
                    <FieldMultiSelect injectClass={'bg-white'} label={t(`Profession`)} fieldProps={additionalForm.getFieldProps('expectedOccupation')} fieldMeta={additionalForm.getFieldMeta('expectedOccupation')} fieldHelper={additionalForm.getFieldHelpers('expectedOccupation')} edit={true} dataLoaded={true} options={lang === 'en' ? occupation : tOccupation} />
                    <FieldInput injectClass={'bg-white'} label={t(`Salary`)} fieldProps={additionalForm.getFieldProps('expectedSalary')} fieldMeta={additionalForm.getFieldMeta('expectedSalary')} fieldHelper={additionalForm.getFieldHelpers('expectedSalary')} edit={true} dataLoaded={true} />
                    <FieldMultiSelect injectClass={'bg-white'} label={t(`Status`)} fieldProps={additionalForm.getFieldProps('expectedStatus')} fieldMeta={additionalForm.getFieldMeta('expectedStatus')} fieldHelper={additionalForm.getFieldHelpers('expectedStatus')} edit={true} dataLoaded={true} options={lang === 'en' ? status : tStatus} />
                    <FieldInput injectClass={'bg-white'} label={t(`Expectation`)} fieldProps={additionalForm.getFieldProps('expectation')} fieldMeta={additionalForm.getFieldMeta('expectation')} fieldHelper={additionalForm.getFieldHelpers('expectation')} edit={true} dataLoaded={true} />
                    <FieldInput injectClass={'bg-white'} type="password" label={t(`Password`)} fieldProps={additionalForm.getFieldProps('password')} fieldMeta={additionalForm.getFieldMeta('password')} fieldHelper={additionalForm.getFieldHelpers('password')} edit={true} dataLoaded={true} />
                    <FieldInput injectClass={'bg-white'} type="password" label={t(`Confirm Password`)} fieldProps={additionalForm.getFieldProps('confirmPassword')} fieldMeta={additionalForm.getFieldMeta('confirmPassword')} fieldHelper={additionalForm.getFieldHelpers('confirmPassword')} edit={true} dataLoaded={true} />
                </motion.div>
                <motion.div className="w-full flex flex-row justify-end">
                    <motion.div className="w-96 flex flex-row justify-start">
                        <Button injectClass={'rounded-full w-full'} type="secondary" onClick={() => backPage(2)}>{t('Back')}</Button>
                        <Button injectClass={'rounded-full w-full'} type="primary" onClick={() => validateForms(3)}>{t('Next')}</Button>
                    </motion.div>
                </motion.div>
            </motion.div>}
            {/* Page 4 */}
            {page4 && <motion.div className="h-full w-full grid grid-cols-1">
                <motion.div className="w-full flex px-1 gap-2 flex-col h-full py-5 justify-center">
                    <p className="text-4xl font-bold text-primeColor">{t('Contact Information')}</p>
                    <p className="text-md">{t('Fill your contact information')}</p>
                </motion.div>
                <motion.div className="w-full grid grid-cols-1 md:grid-cols-3 sm:grid-cols-1 gap-5">
                    <FieldInput injectClass={'bg-white'} type="phone" label={t('Mobile Number')} fieldProps={contactForm.getFieldProps('mobileNumber')} fieldMeta={contactForm.getFieldMeta('mobileNumber')} fieldHelper={contactForm.getFieldHelpers('mobileNumber')} edit={true} dataLoaded={true}/>
                    <FieldInput injectClass={'bg-white'} type="phone" label={t('Whatsapp Number')} fieldProps={contactForm.getFieldProps('whatsappNumber')} fieldMeta={contactForm.getFieldMeta('whatsappNumber')} fieldHelper={contactForm.getFieldHelpers('whatsappNumber')} edit={true} dataLoaded={true} />
                    <FieldInput injectClass={'bg-white'} placeholder={t('Email')} label={t(`Email`)} fieldProps={contactForm.getFieldProps('email')} fieldMeta={contactForm.getFieldMeta('email')} fieldHelper={contactForm.getFieldHelpers('email')} edit={true} dataLoaded={true} />
                    <div></div>
                    <div></div>
                </motion.div>
                <motion.div className="w-full flex px-5 flex-col my-5 justify-center">
                    <p className="text-xl font-bold text-primeColor">{t('Present Address')}</p>
                </motion.div>
                <motion.div className="w-full h-full grid grid-cols-1 md:grid-cols-4 sm:grid-cols-1 gap-5">
                    <FieldInput injectClass={'bg-white'} label={t(`Pincode`)} fieldProps={contactForm.getFieldProps('presentAddress.pinCode')} fieldMeta={contactForm.getFieldMeta('presentAddress.pinCode')} fieldHelper={contactForm.getFieldHelpers('presentAddress.pinCode')} edit={true} dataLoaded={true} onChange={(ev) => getPresentAddress(ev)} />
                    <FieldInput injectClass={'bg-white'} label={t('Address Line 1')} fieldProps={contactForm.getFieldProps('presentAddress.addressLine1')} fieldMeta={contactForm.getFieldMeta('presentAddress.addressLine1')} fieldHelper={contactForm.getFieldHelpers('presentAddress.addressLine1')} edit={true} dataLoaded={true} />
                    <FieldInput injectClass={'bg-white'} label={t(`Address Line 2`)} fieldProps={contactForm.getFieldProps('presentAddress.addressLine2')} fieldMeta={contactForm.getFieldMeta('presentAddress.addressLine2')} fieldHelper={contactForm.getFieldHelpers('presentAddress.addressLine2')} edit={true} dataLoaded={true} />
                    <FieldInput injectClass={'bg-white'} label={t(`City`)} fieldProps={contactForm.getFieldProps('presentAddress.city')} fieldMeta={contactForm.getFieldMeta('presentAddress.city')} fieldHelper={contactForm.getFieldHelpers('presentAddress.city')} edit={true} dataLoaded={true} />
                    <FieldInput injectClass={'bg-white'} label={t(`District`)} fieldProps={contactForm.getFieldProps('presentAddress.district')} fieldMeta={contactForm.getFieldMeta('presentAddress.district')} fieldHelper={contactForm.getFieldHelpers('presentAddress.district')} edit={true} dataLoaded={true} />
                    <FieldInput injectClass={'bg-white'} label={t(`State`)} fieldProps={contactForm.getFieldProps('presentAddress.state')} fieldMeta={contactForm.getFieldMeta('presentAddress.state')} fieldHelper={contactForm.getFieldHelpers('presentAddress.state')} edit={true} dataLoaded={true} />
                    <motion.div className="flex flex-row w-full items-center">
                        <input type="checkbox" defaultChecked={contactForm.values.isSameAddress} onChange={(ev) => sameAddress(ev)} />&nbsp;{t('Present Address is your native address')}
                    </motion.div>
                </motion.div>
                <motion.div className="w-full flex px-5 flex-col my-5 justify-center">
                    <p className="text-xl font-bold text-primeColor">{t('Native Address')}</p>
                </motion.div>
                <motion.div className="w-full h-full grid grid-cols-1 md:grid-cols-4 sm:grid-cols-1 gap-5">
                    <FieldInput injectClass={'bg-white'} disabled={contactForm.values.isSameAddress} label={t(`Pincode`)} fieldProps={contactForm.getFieldProps('nativeAddress.pinCode')} fieldMeta={contactForm.getFieldMeta('nativeAddress.pinCode')} fieldHelper={contactForm.getFieldHelpers('nativeAddress.pinCode')} edit={true} dataLoaded={true} onChange={(ev) => getNativeAddress(ev)} />
                    <FieldInput injectClass={'bg-white'} disabled={contactForm.values.isSameAddress} label={t('Address Line 1')} fieldProps={contactForm.getFieldProps('nativeAddress.addressLine1')} fieldMeta={contactForm.getFieldMeta('nativeAddress.addressLine1')} fieldHelper={contactForm.getFieldHelpers('nativeAddress.addressLine1')} edit={true} dataLoaded={true} />
                    <FieldInput injectClass={'bg-white'} disabled={contactForm.values.isSameAddress} label={t(`Address Line 2`)} fieldProps={contactForm.getFieldProps('nativeAddress.addressLine2')} fieldMeta={contactForm.getFieldMeta('nativeAddress.addressLine2')} fieldHelper={contactForm.getFieldHelpers('nativeAddress.addressLine2')} edit={true} dataLoaded={true} />
                    <FieldInput injectClass={'bg-white'} disabled={contactForm.values.isSameAddress} label={t(`City`)} fieldProps={contactForm.getFieldProps('nativeAddress.city')} fieldMeta={contactForm.getFieldMeta('nativeAddress.city')} fieldHelper={contactForm.getFieldHelpers('nativeAddress.city')} edit={true} dataLoaded={true} />
                    <FieldInput injectClass={'bg-white'} disabled={contactForm.values.isSameAddress} label={t(`District`)} fieldProps={contactForm.getFieldProps('nativeAddress.district')} fieldMeta={contactForm.getFieldMeta('nativeAddress.district')} fieldHelper={contactForm.getFieldHelpers('nativeAddress.district')} edit={true} dataLoaded={true} />
                    <FieldInput injectClass={'bg-white'} disabled={contactForm.values.isSameAddress} label={t(`State`)} fieldProps={contactForm.getFieldProps('nativeAddress.state')} fieldMeta={contactForm.getFieldMeta('nativeAddress.state')} fieldHelper={contactForm.getFieldHelpers('nativeAddress.state')} edit={true} dataLoaded={true} />
                </motion.div>
                <motion.div className="w-full flex flex-row justify-end">
                    <motion.div className="w-96 flex flex-row justify-start">
                        <Button injectClass={'rounded-full w-full'} type="secondary" onClick={() => backPage(3)}>{t('Back')}</Button>
                        <Button injectClass={'rounded-full w-full'} type="primary" onClick={() => validateForms(4)}>{t('Next')}</Button>
                    </motion.div>
                </motion.div>
            </motion.div>}
            {page5 && <motion.div className="h-full w-full overflow-scroll grid grid-cols-1">
                <motion.div className="w-full flex px-1 gap-2 flex-col h-full py-5 justify-center">
                    <p className="text-4xl font-bold text-primeColor">{t('Upload Images and Horoscope Information')}</p>
                </motion.div>
                <motion.div className="h-full">
                    <p className="px-2 text-xl font-bold text-primeColor">{t('Upload Image')}</p>
                    <Dropzone className="relative my-5"
                        onChange={updateFiles}
                        value={files}
                        accept="image/*"
                        maxFiles={5}
                    >
                        {files.map((file) => (
                            <FileMosaic preview={true} key={file.id} {...file} onDelete={removeFile} info />
                        ))}
                    </Dropzone>
                </motion.div>
                <motion.div className="h-full gap-2 w-full">
                    <p className="px-2 text-xl font-bold text-primeColor">{t('Upload Horoscope')}</p>
                    <motion.div className="h-full relative gap-1 w-full">
                                                <motion.div className="flex flex-col w-full gap-1">
                        <RasiKattam setRasiValues={(ev) => setRasiValues(ev)} rasiValues={rasiValues} />
                        <AmsaKattam setAmsaValues={(ev) => setAmsaValues(ev)} amsaValues={amsaValues} />
                            </motion.div>
                    </motion.div>
                </motion.div>
                <motion.div className="w-full flex flex-row justify-end">
                    <motion.div className="w-96 flex flex-row justify-start">
                        <Button injectClass={'rounded-full w-full'} type="secondary" onClick={() => backPage(4)}>{t('Back')}</Button>
                        <Button injectClass={'rounded-full w-full'} type="primary" onClick={() => validateForms(5)}>{t('Next')}</Button>
                    </motion.div>
                </motion.div>
            </motion.div>}
            <Dialog title="Preview Registration" injectClass="max-w-[2400px]" showDialog={previewDialog} onClose={() => { setPreviewDialog(false); localStorage.removeItem('registerValues') }}>
                <motion.div className={'flex flex-col relative w-full min-h-screen'}>
                    <motion.div className="py-10">
                        <PreviewUser registration={true} userValues={registerForm.values} />
                    </motion.div>
                    <motion.div className="flex py-2 flex-row w-full items-center  inset-x-0 bottom-0 justify-center">
                        <motion.div className={`w-fit ${submitDisabled ? 'cursor-not-allowed' : 'cursor-pointer'} px-2 py-1 rounded-full drop-shadow-lg bg-primeColor text-white`} onClick={() => !submitDisabled && registerForm.submitForm()}>
                            Register
                        </motion.div>
                    </motion.div>
                </motion.div>
            </Dialog >
        </motion.div >
    )
}

export default Signup